export const AUTO_NUMBERING_CONFIG_TYPE = {
    LEGISLATIVE_ITEM: 'LEGISLATIVE_ITEM',
    DOCUMENT: 'DOCUMENT',
    SEAT_APPLICATION: 'SEAT_APPLICATION',
};
export const SEAT_APPLICATION_AUTO_NUMBERING_CONFIG = {
    name: 'Seat Application',
    formula: '[YEAR]-[COUNTER]',
    startingCounter: 1,
    restartYearly: true,
    counterPadding: 3,
    description: 'Auto-numbering configuration for seat applications',
    isActive: true,
    type: AUTO_NUMBERING_CONFIG_TYPE.SEAT_APPLICATION,
};
export const LEGISLATIVE_ITEM_AUTO_NUMBERING_CONFIG = {
    name: 'Legislative Item',
    description: 'Default auto-numbering configuration for legislative items',
    formula: '[YEAR]-[ITEM_TYPE_CODE]-[COUNTER]',
    startingCounter: 1,
    restartYearly: true,
    counterPadding: 3,
    isActive: true,
    type: AUTO_NUMBERING_CONFIG_TYPE.LEGISLATIVE_ITEM,
};
export const DOCUMENT_AUTO_NUMBERING_CONFIG = {
    name: 'Document',
    description: 'Default auto-numbering configuration for documents',
    formula: '[YEAR]-[DOC_TYPE_CODE]-[COUNTER]',
    startingCounter: 1,
    restartYearly: true,
    counterPadding: 3,
    isActive: true,
    type: AUTO_NUMBERING_CONFIG_TYPE.DOCUMENT,
};
export const DEFAULT_AUTO_NUMBERING_CONFIGS = [
    LEGISLATIVE_ITEM_AUTO_NUMBERING_CONFIG,
    DOCUMENT_AUTO_NUMBERING_CONFIG,
    SEAT_APPLICATION_AUTO_NUMBERING_CONFIG,
];
